import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./card.scss";
import { isLocalhost } from "../../../../checkLocalhost.jsx";
import { useState,useEffect } from "react";

import home3 from "../../../assets/home3.png";
// import pin from "../../assets/pin.png";
import features from "../../../assets/features.png";
import bed from "../../../assets/bed.png";
import bath from "../../../assets/bath.png";
import size from "../../../assets/size.png";
import rupeesign from "../../../assets/rupee-sign_10432907.png";
import save from "../../../assets/save.png";
import chat from "../../../assets/chat.png";
import noimage from "../../../assets/no-image-icon-23494.png";
import { AuthContext } from "../../../context/AuthContext.jsx";
import apiRequest from "../../../lib/apiRequest.js";
import { formatToIndianRupees, generatePostMessage } from "../../../lib/allPurposeFunctions.js";
import { MapPinIcon } from "../../../lib/myIcons.jsx";
import  DOMPurify  from 'dompurify';



// const postimageslocation = import.meta.env.VITE_POSTIMAGES_BASEURL;

function Card({
  item,
  selected,
  onNavigateSavePost,
  onNavigatePostView,
  onCardSelectChange,
  showCheckbox = false,
  onMarkMessaged,
  showPhone,
}) {
  /// these are property types of square ft
  // const exropertytypeIds = [1, 2, 4, 9, 12, 13, 25, 27, 29, 31, 34, 35, 36];

  // console.log("Card Item: ",item)
  // console.log("ShowPhone: ",showPhone)

  const navigate = useNavigate();
  // const [selected, setSelected] = useState(false);  //

  const { currentUser } = useContext(AuthContext);
  //  const SERVER_DBASEURL = import.meta.env.VITE_DSERVER_APIURL;

  // const builderimageslocation=import.meta.env.VITE_IS_LOCALHOST=='true'
  // ?"http://localhost:5173/"
  // :"http://fulcrumengineers.in/"

  //  const builderimageslocation=import.meta.env.VITE_IS_LOCALHOST=='true'
  const builderimageslocation = isLocalhost
    ? import.meta.env.VITE_SERVER_BASEURL + "/"
    : import.meta.env.VITE_SH_DSERVER_BASEURL + "/";

  //  const SERVER_DBASEURL=  import.meta.env.VITE_IS_LOCALHOST=='true'
  const SERVER_DBASEURL = isLocalhost
    ? import.meta.env.VITE_DSERVER_BASEURL + import.meta.env.VITE_API
    : import.meta.env.VITE_SH_DSERVER_BASEURL + import.meta.env.VITE_API;

  const [hasMessaged, setHasMessaged] = useState(item.messaged == 1);
  useEffect(() => {
    setHasMessaged(item.messaged == 1);
  }, [item.messaged]);

  const [hasSaved, setHasSaved] = useState(item.savedpost == 1);
  useEffect(() => {
    setHasSaved(item.savedpost == 1);
  }, [item.savedpost]);

  const handleUserProfileClick = (userId) => (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent the click from propagating to the card
    // console.log("User ID:", userId); // Log the user ID to the console

    navigate(`/displayprofile/${userId}`);
  };

  // const defaultCardClick = (e) => {
  //     e.preventDefault();
  //     e.stopPropagation();

  //     const isOwner = currentUser && Post.userid === currentUser.id;
  //     // ✅ If parent wants control, delegate and STOP
  //       if (onNavigateSavePost || onNavigatePostView) {
  //         if (isOwner) {
  //           onNavigateSavePost?.(Post);
  //         } else {
  //           onNavigatePostView?.(Post);
  //         }
  //         return; // 🚨 DO NOTHING ELSE
  //       }
  //     // if (currentUser && Post.userid === currentUser.id) {

  //     if (isOwner) {
  //       navigate('/dashboard/savepost', {
  //         state: { mode: 0, postid: Post.id },
  //       });
  //     } else {
  //       apiRequest.post(`/posts/view/${Post.id}`, {
  //         postid: Post.id,
  //         userid: currentUser ? currentUser.id : null,
  //       });
  //       navigate(`/${Post.id}`);
  //     }

  //   };

  const handleCardClick = (Post) => (e) => {
    e.preventDefault();
    // alert(Post.id)
    e.stopPropagation(); // Prevent the click from propagating to the card

    // if (currentUser && Post.userid === currentUser.id) {
    //     navigate('/dashboard/savepost', { state: { mode: 0, postid: Post.id } });
    // } else {
    //   ///
    //   const res=apiRequest.post(`/posts/view/${Post.id}`, {
    //     postid: Post.id,
    //     userid:currentUser?currentUser.id:null,
    //   });
    //   navigate(`/${Post.id}`);
    // }

    const isOwner = currentUser && Post.userid === currentUser.id;
    // ✅ If parent wants control, delegate and STOP
    if (onNavigateSavePost || onNavigatePostView) {
      if (isOwner) {
        onNavigateSavePost?.(Post);
      } else {
        // apiRequest.post(`/posts/view/${Post.id}`, {
        //   postid: Post.id,
        //   userid: currentUser ? currentUser.id : null,
        // });
        onNavigatePostView?.(Post);
      }
      return; // 🚨 DO NOTHING ELSE
    }
    // if (currentUser && Post.userid === currentUser.id) {
    if (isOwner) {
      navigate("/dashboard/savepost", {
        state: { mode: 0, postid: Post.id },
      });
    } else {
      // apiRequest.post(`/posts/view/${Post.id}`, {
      //   postid: Post.id,
      //   userid: currentUser ? currentUser.id : null,
      // });

      navigate(`/${Post.id}`);
    }
  };

  // const handleCheckboxChange = (e) => {
  //   e.stopPropagation();
  //   // onSelectChange?.(item.id, e.target.checked);
  //   setSelected(e.target.checked);  // update local state
  // };

  // const handleCheckboxChange = (e) => {
  //   e.stopPropagation();
  //   onSelectChange?.(item.id, e.target.checked);  // call parent handler
  // };

  const handleCheckboxChange = (e) => {
    e.stopPropagation();
    // console.log("Card checkbox changed:", item.id, e.target.checked);
    onCardSelectChange?.(item.id, e.target.checked);
  };

  const handleSendMessage = (item) => (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent the click from propagating to the card
    // alert("Send message to " + item);
    // console.log("Send message to:", item);

    if (hasMessaged) {
      alert("You have already sent a message for this property.");
      return; // Exit if the user has already messaged
    }

    const message = generatePostMessage(item, currentUser.username);
    // console.log("Message to send:", message);

    // console.log("messaged",item.messaged);

    if (!currentUser) {
      navigate("/login");
      return;
    }

    const postChatMessage = async () => {
      try {
        const res = await apiRequest.post("/chats/chatmessage", {
          receiverid: item.userid,
          text: message,
          postid: item.id, // Pass the post ID
        });
        // console.log("Chat response:", res.data);
        // console.log("Chat ID:", res.data.id);
        // const message="Hello, I would like to inquire about the property you posted. Could you please provide more details? Thank you!";
      } catch (error) {
        console.error("Error sending message:", error);
      }
    };
    postChatMessage();

    setHasMessaged(true); // local highlight
    onMarkMessaged?.(); // notify parent to update post.messaged = 1
  };

  const handleSavePost = (item) => (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent the click from propagating to the card
    // alert("Send message to " + item);
    // console.log("Send message to:", item);

    if (!currentUser) {
      navigate("/login");
      return;
    }

    const SavePost = async () => {
      try {
        const res = await apiRequest.post("/users/save", { postid: item.id });
        // console.log("Chat response:", res.data);
      } catch (error) {
        console.error("Error sending message:", error);
      }
    };
    SavePost();

    setHasSaved(!hasSaved); // local highlight
    // onMarkMessaged?.();           // notify parent to update post.messaged = 1
  };

  const getClientType = (clienttype) => {
    // If it's already a normal string like "Broker"
    if (typeof clienttype === "string" && !clienttype.startsWith("[")) {
      return clienttype;
    }

    // If it's a stringified array like ["Builder"]
    try {
      const parsed = JSON.parse(clienttype);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return (
          parsed
            .filter((val) => String(val).trim().toLowerCase() !== "unknown")
            .map(String)
            .join(", ") || "Seller"
        );
      }
    } catch (e) {
      // ignore JSON parse errors
    }

    return "Seller"; // fallback
  };

  return (
    <div className="card">
      {/* ⬇️ Added checkbox for selection */}

      {/* <input
        type="checkbox"
        className="selectCheckbox"
        checked={selected || false}
        onChange={handleCheckboxChange}
        style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 10 }}
      /> */}

      {showCheckbox && (
        <input
          type="checkbox"
          className="selectCheckbox"
          checked={selected || false}
          onChange={handleCheckboxChange}
          // style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 10 }}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 10,
            display: showCheckbox ? "block" : "none",
          }}
        />
      )}

      {/* <Link to={"/#"} className="imageContainer" onClick={handleCardClick(item)}> */}

      {/* <Link to="/#" className="imageContainer" onClick={() => handleCardClick(item.id)}> */}

      <div className="imageContainer" onClick={handleCardClick(item)}>
        {/* {console.log("Item Images",item)} */}

        {item.images && item.images.length > 0 ? (
          (() => {
            //          const postimageslocation = import.meta.env.VITE_IS_LOCALHOST=='true'
            const postimageslocation = isLocalhost
              ? import.meta.env.VITE_POSTIMAGES_BASEURL +
                item.userid +
                "/posts/"
              : import.meta.env.VITE_POSTIMAGES_SH_BASEURL +
                item.userid +
                "/posts/";

            // console.log("post Image location: ",postimageslocation)
            // const firstImage = item.images[0] || "";
            const firstImage = String(item.images?.[0] || "");

            // if (item.id==='6434'){
            //   console.log("images",item.images)
            //   console.log("First Image",firstImage)

            // }


            const propimage =
              item.builderpost == "1"
                ? builderimageslocation + firstImage
                : firstImage.startsWith("http")
                  ? firstImage
                  : postimageslocation + firstImage;

            // console.log("First Image",firstImage);
            // console.log("propimage",propimage);

            // console.log("card image: ", firstImage);
            // console.log("Card Item: ", item);

            return (
              <img
                src={propimage}
                alt=""
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noimage;
                  e.target.style.width = "150px";
                  e.target.style.height = "150px";
                  e.target.style.display = "block";
                }}
              />
            );
          })()
        ) : (
          <img src={home3} alt="No image available" />
        )}
      </div>

      <div className="textContainer">
        <h2 className="title">
          {/* <Link to={`/${item.id}`}>{item.title}</Link> */}
          {/* <Link to={"/#"} onClick={handleCardClick(item)}>{item.title}</Link> */}
          <div onClick={handleCardClick(item)}>{item.title}</div>
        </h2>
        <p className="transprop">
          {item.propertytypetag + " " + item.transtypetag}
        </p>

        <p className="address">
          {/* <img src={pin} alt="" /> */}

          <MapPinIcon size={"16px"} color="grey"></MapPinIcon>

          <span>
            {[
              item.block,
              item.plotno,
              item.address1,
              item.address2,
              item.colonyname,
              item.city,
            ]
              .filter(Boolean)
              .join(", ")}
          </span>
          {/* <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(item.description),
            }}
          /> */}
        </p>

        {/* <p style={{width: 'auto',wordWrap:true,whiteSpace:'normal'}}>
          {JSON.stringify(item)}          
        </p> */}

        <div className="tags">
          {/* {console.log("Cards item.tags:",item.tags)} */}
          <img src={features} alt="" />
          <span>{item.tags} </span>
        </div>

        {/* <div className="tags">
        <img
          src={features}
          alt=""
          onError={(e) => {
            e.target.onerror = null; // prevents looping in case fallback also fails
            e.target.src = noimage; // fallback image URL
          }}
        />
        <span>{item.tags}</span>
      </div> */}

        <div className="price">
          <div className="features">
            {item.bedroom > 0 && (
              <div className="feature">
                <img src={bed} alt="" />
                <span>{item.bedroom} bedroom</span>
              </div>
            )}

            {item.bathroom > 0 && (
              <div className="feature">
                <img src={bath} alt="" />
                <span>{item.bathroom} bathroom</span>
              </div>
            )}

            <div className="feature">
              <img src={size} alt="" />
              <span>{item.plotsize + " " + item.plotsizename}</span>
            </div>

            {/* <div className="feature">
              <img src={rupeesign} alt="" />
              <span>{item.price}</span>
            </div> */}
            <div className="feature">
              <img src={rupeesign} alt="" />
              <span>
                {item.price && item.price > 0
                  ? formatToIndianRupees(item.price)
                  : "On Request"}
              </span>
            </div>
          </div>
        </div>
        {/* <p className="price"></p> */}

        <div className="bottom">
          <div className="icons">
            {currentUser && currentUser?.id !== item.userid && (
              <>
                <div
                  className={`icon ${hasSaved ? "has-saved" : ""}`}
                  title={hasSaved ? "Unsave this post" : "Save this post"}
                  onClick={handleSavePost(item)}
                >
                  <img src={save} alt="" />
                </div>
                <div
                  className={`icon ${hasMessaged ? "has-messaged" : ""}`}
                  onClick={handleSendMessage(item)}
                  title={
                    hasMessaged
                      ? "You’ve already sent a message"
                      : "Send a message"
                  }
                >
                  <img src={chat} alt="" />
                </div>
              </>
            )}

            <div
              className="usertype"
              onClick={handleUserProfileClick(item.userid)}
            >
              <div className="clientType">
                {/* {console.log("card Item.clienttype: ",item.clienttype)} */}
                {/* {item.clienttype=='Unknown'?
                    "Seller":item.clienttype
                  }
                   */}

                {getClientType(item.clienttype)}
              </div>
              <div className="clientName">
                {item.name}

                {item.bldrnumbers && showPhone && (
                  <>
                    {" "}
                    {/* {JSON.parse(item.bldrnumbers).join(", ")} */}
                    {Array.isArray(item.bldrnumbers)
                      ? item.bldrnumbers.join(", ")
                      : item.bldrnumbers}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
